import { styled } from '@mui/system';
import { Box } from '@mui/system';

export const Container = styled(Box)({
  height: 'calc(100vh - 187px)',
  padding: '0',
  transition: 'flex 0.3s ease-in-out',
});

export const Header = styled('div')({
  marginBottom: '16px',
});
